import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Row,
  Col,
  Container,
} from "reactstrap";
import axios from "axios";
import Select from "react-select";
import { notificationUtils } from "@/utils/notificationToast";
import { tryCatch } from "@/helpers/async_helper";
import api from "@/shared/services/api";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputForm from "@/components/Form/Inputs/InputForm";
import SelectForm from "@/components/Form/Inputs/SelectForm";
// import { DndProvider, useDrag, useDrop } from "react-dnd";
import Breadcrumbs from "@components/Common/Breadcrumb";

// Interfaces
const ItemType = {
  MODULE: "module",
};

// const ModuleComponent = ({ module, index, moveModule, type }) => {
//   const [, ref] = useDrag({
//     type: ItemType.MODULE,
//     item: { index, type },
//   });

//   const [, drop] = useDrop({
//     accept: ItemType.MODULE,
//     hover: (draggedItem) => {
//       if (draggedItem.index !== index || draggedItem.type !== type) {
//         moveModule(draggedItem.index, index, draggedItem.type, type);
//         draggedItem.index = index;
//         draggedItem.type = type;
//       }
//     },
//   });

//   return (
//     <div ref={(node) => ref(drop(node))} className="module-item">
//       {module.name}
//     </div>
//   );
// };

interface Props {
  isEdit?: boolean;
  itemEdit?: any;
}

const FormPage = ({ isEdit, itemEdit }: Props) => {
  const navigate = useNavigate();

  const form = useFormik({
    initialValues: {
      name: itemEdit?.name || "",
      commercialActivity: itemEdit?.commercialActivity || "",
      website: itemEdit?.website || "",
      email: itemEdit?.email || "",
      rif: itemEdit?.rif || "",
      address: itemEdit?.address || "",
      phone: itemEdit?.phone || "",
      contactDetails: {
        name: itemEdit?.contactDetails?.name || "",
        lastname: itemEdit?.contactDetails?.lastname || "",
        email: itemEdit?.contactDetails?.email || "",
        phone: itemEdit?.contactDetails?.phone || "",
        identification: itemEdit?.contactDetails?.identification || "",
      },
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Ingresa un nombre"),
      commercialActivity: Yup.string().required(
        "Ingresa una actividad comercial"
      ),
      website: Yup.string().url("Formato de URL inválido"),
      email: Yup.string()
        .email("Formato de correo inválido")
        .required("Ingresa un correo electrónico"),
      rif: Yup.string().required("Ingresa un RIF"),
      address: Yup.string().required("Ingresa una dirección"),
      phone: Yup.string().required("Ingresa un número de teléfono"),
      contactDetails: Yup.object({
        name: Yup.string().required("Ingresa un nombre"),
        lastname: Yup.string().required("Ingresa un apellido"),
        email: Yup.string()
          .email("Formato de correo inválido")
          .required("Ingresa un correo electrónico"),
        phone: Yup.string().required("Ingresa un número de teléfono"),
        identification: Yup.string().required("Ingresa una identificación"),
      }),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      const data = values;
      const { data: response, error } = await tryCatch(
        isEdit
          ? api.put(`/enterprise/${itemEdit._id}`, data)
          : api.post("/enterprise/", data)
      );
      if (error || response === null) {
        console.error("Error:", error);
        const errorMessage =
          (error as any)?.response?.data?.message ||
          (error as any)?.response?.data;
        notificationUtils("danger", errorMessage);
      } else {
        notificationUtils("success", "Guardado con éxito");
        navigate("/enterprise/list");
      }
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs
          title="Listado de empresas"
          url="/enterprise/list"
          breadcrumbItem={isEdit ? "Editar empresa" : "Crear empresa"}
        />
        <Form onSubmit={form.handleSubmit}>
          <h5 className="mt-4">Datos de empresa</h5>
          <Row>
            <Col md={6}>
              <FormGroup>
                {/* <Label for="name">Nombre</Label> */}
                <InputForm
                  label="Nombre"
                  type="text"
                  name="name"
                  value={form.values.name}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.name}
                  errors={form.errors.name}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Actividad Comercial"
                  type="text"
                  name="commercialActivity"
                  value={form.values.commercialActivity}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.commercialActivity}
                  errors={form.errors.commercialActivity}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Website"
                  type="text"
                  name="website"
                  value={form.values.website}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.website}
                  errors={form.errors.website}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                {/* <Label for="name">Nombre</Label> */}
                <InputForm
                  label="Correo"
                  type="text"
                  name="email"
                  value={form.values.email}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.email}
                  errors={form.errors.email}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="RIF"
                  type="text"
                  name="rif"
                  value={form.values.rif}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.rif}
                  errors={form.errors.rif}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Dirección"
                  type="text"
                  name="address"
                  value={form.values.address}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.address}
                  errors={form.errors.address}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Teléfono"
                  type="text"
                  name="phone"
                  value={form.values.phone}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.phone}
                  errors={form.errors.phone}
                />
              </FormGroup>
            </Col>
          </Row>

          <h5 className="mt-4">Detalles de contacto</h5>
          <Row>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Nombre"
                  type="text"
                  name="contactDetails.name"
                  value={form.values.contactDetails.name}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.contactDetails?.name}
                  errors={form.errors.contactDetails?.name}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Apellido"
                  type="text"
                  name="contactDetails.lastname"
                  value={form.values.contactDetails.lastname}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.contactDetails?.lastname}
                  errors={form.errors.contactDetails?.lastname}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Correo"
                  type="text"
                  name="contactDetails.email"
                  value={form.values.contactDetails.email}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.contactDetails?.email}
                  errors={form.errors.contactDetails?.email}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Teléfono"
                  type="text"
                  name="contactDetails.phone"
                  value={form.values.contactDetails.phone}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.contactDetails?.phone}
                  errors={form.errors.contactDetails?.phone}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <InputForm
                  label="Identificación"
                  type="text"
                  name="contactDetails.identification"
                  value={form.values.contactDetails.identification}
                  onChange={form.handleChange}
                  onBlur={form.handleBlur}
                  touched={form.touched.contactDetails?.identification}
                  errors={form.errors.contactDetails?.identification}
                />
              </FormGroup>
            </Col>
          </Row>

          <div className="d-flex justify-content-between">
            <Button
              type="button"
              color="secondary"
              onClick={() => {
                navigate("/users/list");
              }}
            >
              Cancelar
            </Button>

            <Button type="submit" color="primary" disabled={form.isSubmitting}>
              {form.isSubmitting
                ? "Guardando..."
                : isEdit
                ? "Actualizar"
                : "Guardar"}
            </Button>
          </div>
        </Form>
      </Container>
    </div>
  );
};

export default FormPage;
